import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class FortressSunken2PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.FORTRESS_SUNKEN2;
}

export default FortressSunken2PoiTileEntity;
